import { trackingFlowStepDetailsOptions, trackingFlowStepInitialData } from './redemption-error.constants';
import { REDEMPTION_STATUS } from '../redemption.constants';

export const getTrackingFlowStepDetails = ({ status, maintenanceMode }: {
    status: string,
    maintenanceMode: boolean
}) => {
    if (maintenanceMode) {
        return trackingFlowStepDetailsOptions[REDEMPTION_STATUS.MAINTENANCE_ERROR];
    }

    return trackingFlowStepDetailsOptions[status] ||
        trackingFlowStepDetailsOptions[REDEMPTION_STATUS.GENERIC_ERROR];
};

export const getTrackingFlowStepInitialData = (status: string) => {
    if (trackingFlowStepDetailsOptions[status] === 'not eligible') {
        return {
            ...trackingFlowStepInitialData,
            action: 'error : not eligible',
        };
    }

    return trackingFlowStepInitialData;
};
